import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { BANNER_CACHE_KEYS } from "./keys";

import { BannerRepository } from "@/repositories/banner";
import { UpdateBanner } from "@/types";

export const useUpdateBanner = () => {
  const queryClient = useQueryClient();
  const bannerRepository = useRef(new BannerRepository());

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateBanner }) =>
      bannerRepository.current.update(id, data),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: BANNER_CACHE_KEYS.LIST }),
  });
};
